/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-04-03 09:37:04
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-26 10:28:12
 * @FilePath: \合联\oms\src\locale\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import { localRead } from "@/libs/util";
import customZhCn from "./lang/zh-CN";
import customZhTw from "./lang/zh-TW";
import customEnUs from "./lang/en-US";
import zhCnLocale from "iview/src/locale/lang/zh-CN";
import enUsLocale from "iview/src/locale/lang/en-US";
import zhTwLocale from "iview/src/locale/lang/zh-TW";
let newCustomZhCn = {}
Object.keys(customZhCn).map(k => newCustomZhCn[customZhCn[k]] = k)
Vue.use(VueI18n);

// 自动根据浏览器系统语言设置语言
const navLang = navigator.language;
const localLang =
	navLang === "zh-CN" || navLang.indexOf("en") != -1 ? "en-US" : false;
let lang =
	localRead("local") || navLang.indexOf("en") != -1 ? "en-US" : "zh-CN";
Vue.config.lang = lang;
// vue-i18n 6.x+写法
Vue.locale = () => { };
const messages = {
	"zh-CN": Object.assign(zhCnLocale, customZhCn),
	"zh-TW": Object.assign(zhTwLocale, customZhTw),
	"en-US": Object.assign(enUsLocale, customEnUs),
};
const i18n = new VueI18n({
	locale: localRead("local") || lang,
	messages,
});

export default i18n;

// vue-i18n 5.x写法
// Vue.locale('zh-CN', Object.assign(zhCnLocale, customZhCn))
// Vue.locale('en-US', Object.assign(zhTwLocale, customZhTw))
// Vue.locale('zh-TW', Object.assign(enUsLocale, customEnUs))

let data = {"$schema":"http://json-schema.org/draft-04/schema#","type":"object","properties":{"code":{"type":"number"},"status":{"type":"boolean"},"msg":{"type":"string"},"payload":{"type":"object","properties":{"rows":{"type":"array","items":{"type":"object","properties":{"id":{"type":"number"},"airway_bill_number":{"type":"string","description":"订单号"},"finance_status":{"type":"number"},"to_country":{"type":"string","description":"目的过"},"outbound_time":{"type":"string","description":"出库时间"},"client_refer_code":{"type":"string","description":"客户原单号"},"to_country_currency":{"type":"string","description":"货币"},"clientInfo":{"type":"object","properties":{"client_account":{"type":"string"},"shipper_company_cn":{"type":"string"},"ownership_name":{"type":"string"},"salesman_account":{"type":"string"}}},"finance_status_txt":{"type":"string","description":"结算状态"},"mawb":{"type":"string","description":"提单号"},"values":{"type":"string","description":"申报价值"},"vat_fee":{"type":"string","description":"税费"}},"required":["id","airway_bill_number","finance_status","to_country","outbound_time","client_refer_code","to_country_currency","clientInfo","finance_status_txt","mawb","values","vat_fee"]}},"total":{"type":"number"}}}}}
let cns = {}
Object.keys(customZhCn).forEach(t => {
	cns[customZhCn[t]] = t
})
data = data.properties.payload.properties ? (data.properties.payload.properties.rows ? data.properties.payload.properties.rows.items.properties : data.properties.payload.properties) : data.properties.payload.items.properties
console.log(Object.keys(data).reduce((a, t) => {
	let item = data[t]
	if (item.type === 'object') {
		Object.keys(item.properties).forEach(c => {
			let child = item.properties[c]
			child.description && a.push(`
		{
			name:()=>this.$tz("${child.description}"),
			key:"${t}.${c}",
			minWidth:130,
		}`)
		})
	} else {
		item.description && a.push(`
		{
			name:()=>this.$tz("${item.description}"),
			key:"${t}",
			minWidth:130,
		}`)
	}

	return a
}, []).join())

let transforms = {
	'出库操作记录': '出库,操作,记录',
}
export {
	newCustomZhCn,
	transforms
}
